import type { TransferBatchStatusEnum } from '@frameio/graphql-client/generated';
import { TransferBatchStatus } from '@frameio/shared/transfers/states';
import type { TransferBatch } from '../../../types/uploader';
import { CanceledJobStatus } from './CanceledJobStatus';
import { CancelingJobStatus } from './CancelingJobStatus';
import { ChecksumsProgressJobStatus } from './ChecksumsProgressJobStatus';
import { CompletedJobStatus } from './CompletedJobStatus';
import { InProgressJobStatus } from './InProgressJobStatus';
import { QueuedJobStatus } from './QueuedJobStatus';
import { TranscodeCompleteJobStatus } from './TranscodeCompleteJobStatus';

export const JobStatus = ({
  status,
  job,
  hasPartialFailure,
}: {
  status: TransferBatchStatusEnum;
  job: TransferBatch;
  hasPartialFailure: boolean;
}) => {
  switch (status) {
    case TransferBatchStatus.TRANSFERS_COMPLETE:
    case TransferBatchStatus.ALL_THUMBNAILS_GENERATED:
      return <CompletedJobStatus job={job} />;
      break;
    case TransferBatchStatus.SUCCEEDED:
    case TransferBatchStatus.COMPLETE:
      return <TranscodeCompleteJobStatus job={job} />;
      break;
    case TransferBatchStatus.IDLE:
    case TransferBatchStatus.PROCESSING:
      return <QueuedJobStatus job={job} />;
      break;
    case TransferBatchStatus.DOWNLOADING:
    case TransferBatchStatus.UPLOADING:
      return <InProgressJobStatus job={job} />;
      break;
    case TransferBatchStatus.CHECKSUMS_COMPLETE:
      return <ChecksumsProgressJobStatus job={job} />;
      break;
    case TransferBatchStatus.CANCELING:
      return <CancelingJobStatus />;
      break;
    case TransferBatchStatus.CANCELED:
      return <CanceledJobStatus job={job} />;
      break;
    case TransferBatchStatus.FAILED:
      return hasPartialFailure && <TranscodeCompleteJobStatus job={job} />;
    default:
      return null;
      break;
  }
};
